import { capitalize } from 'lodash';
import { useMultiProjectDashboardContext } from '../../contexts/MultiProjectDashboardContext';
import ExportProjectsCsvButton from './ExportProjectsCsvButton';
import { useAreaUnits } from '../../contexts/UnitContext';

const getColumns = (areaFormatter, longUnitName) => [
  { displayString: 'Farm Name', accessor: 'name' },
  {
    displayString: 'Owner',
    accessor: (row) => row.owner,
    format: ({ firstName, lastName }) =>
      [firstName, lastName].filter((v) => v).join(' '),
  },
  { displayString: 'Owner Contact', accessor: (row) => row.owner?.email },
  { displayString: 'Team', accessor: (row) => row.team?.name },
  {
    displayString: `Total ${capitalize(longUnitName)}`,
    accessor: (row) => row.ecologicalSummary?.acreage,
    format: areaFormatter,
  },
  { displayString: 'Start Year', accessor: 'startYear' },
  {
    displayString: 'Tags',
    accessor: 'tags',
    format: (tags) => tags.join(', '),
  },
  { displayString: 'Address', accessor: 'address' },
  {
    displayString: 'Lat/Lng',
    accessor: (row) => row.mapCenter?.geometry?.coordinates,
    format: (coordinates) =>
      coordinates && `${coordinates[1]},${coordinates[0]}`,
  },
];

const ExportCSVProjectListButton = () => {
  const {
    dashboards: { dashboardFarms },
  } = useMultiProjectDashboardContext();
  const { areaFormatter, longUnitName } = useAreaUnits();

  const fetchData = () => dashboardFarms;
  return (
    <ExportProjectsCsvButton
      columns={getColumns(areaFormatter, longUnitName)}
      exportType="projectList"
      fetchData={fetchData}
      // TODO: For persisted dashboard, add dashboard name to filename?
      filename="projectList.csv"
    />
  );
};

export default ExportCSVProjectListButton;
